import { FC, useState } from "react";
import Nav from "./Nav";
import SideBar from "./SideBar";

export interface CommonLayoutProps {
  children?: React.ReactNode;
}

const Dash: FC<CommonLayoutProps> = ({ children }) => {
  const [hidden, setHidden] = useState("hidden");
  const onClickHandler = () => {
    if (hidden == "hidden") setHidden("");
    else setHidden("hidden");
  };
  return (
    <div>
      <Nav onClickBtn={onClickHandler}></Nav>
      <div className="flex overflow-hidden bg-white pt-16">
        <SideBar hidden={hidden}></SideBar>
        <div
          className="bg-gray-900 opacity-50 hidden fixed inset-0 z-10"
          id="sidebarBackdrop"
        ></div>
        <div
          id="main-content"
          className="h-full w-full bg-gray-50 relative overflow-y-auto lg:ml-64"
        >
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
};

export default Dash;
